import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import useGestoresTipoAprovechamiento from "../../../hooks/administrador/recoleccion/useObtenerGestoresAprov";

const GestoresTipoAprovechamiento = ({
  year,
  mes,
  token,
  idAdministrador,
  provinciaSeleccionada,
  ciudadSeleccionada,
}) => {
  const chartRef = useRef(null);
  const { data, loading, error } = useGestoresTipoAprovechamiento(
    year,
    mes,
    token,
    idAdministrador,
    provinciaSeleccionada,
    ciudadSeleccionada
  );

  useEffect(() => {
    if (loading || !chartRef.current || !data || data.length === 0) return;

    const chartDom = chartRef.current;
    const myChart = echarts.init(chartDom);

    const gestoresMap = {};
    const tiposAprovechamiento = [
      ...new Set(data.map((item) => item.tipo_aprovechamiento)),
    ];

    // Calcular totales por gestor
    data.forEach((item) => {
      if (!gestoresMap[item.gestor_ambiental]) {
        gestoresMap[item.gestor_ambiental] = {
          total: 0,
          tipos: {},
        };
      }

      gestoresMap[item.gestor_ambiental].total += parseInt(item.cantidad_total);
      gestoresMap[item.gestor_ambiental].tipos[item.tipo_aprovechamiento] =
        parseInt(item.cantidad_total);
    });

    // Ordenar gestores por cantidad total (descendente)
    const gestoresOrdenados = Object.keys(gestoresMap).sort(
      (a, b) => gestoresMap[b].total - gestoresMap[a].total
    );

    // Preparar series por tipo de aprovechamiento
    const series = tiposAprovechamiento.map((tipo) => {
      return {
        name: tipo,
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        label: {
          show: false,
          position: "insideRight",
          formatter: "{c}",
        },
        data: gestoresOrdenados.map(
          (gestor) => gestoresMap[gestor].tipos[tipo] || 0
        ),
      };
    });

    const totalNFU = Object.values(gestoresMap).reduce(
      (sum, gestor) => sum + gestor.total,
      0
    );

    const option = {
      title: {
        text: "Gestores por Tipo de Aprovechamiento",
        left: "center",
        subtext: `TOTAL ENTREGADOS: ${totalNFU.toLocaleString()} [U]`,
        subtextStyle: {
          fontWeight: "bold",
          fontSize: "12px",
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: function (params) {
          let total = 0;
        
          const nombreGestor = params[0].axisValue;
          const palabras = nombreGestor.split(" ");
          let nombreFormateado = "";
        
          for (let i = 0; i < palabras.length; i += 2) {
            if (i + 1 < palabras.length) {
              // Usar <br/> en lugar de \n para HTML
              nombreFormateado += palabras[i] + " " + palabras[i + 1] + "<br/>";
            } else {
              nombreFormateado += palabras[i];
            }
          }
        
          let result = `<b>${nombreFormateado}</b>`;  // Quité el <br/> adicional aquí
        
          params.forEach((param) => {
            if (param.value > 0) {
              total += param.value;
              result += `${param.seriesName}: <b>${param.value.toLocaleString()}</b> NFU<br/>`;
            }
          });
        
          result += `<b>Total: ${total.toLocaleString()}</b> NFU`;
          return result;
        }
      },
      legend: {
        data: tiposAprovechamiento,
        bottom: 0,
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "15%",
        top: "15%",
        containLabel: true,
      },
      yAxis: {
        type: "value",
        name: "",
        axisLabel: {
          formatter: function (value) {
            if (value >= 1000) return (value / 1000).toFixed(1) + "K";
            return value;
          },
        },
      },
      xAxis: {
        type: "category",
        data: gestoresOrdenados,
        axisLabel: {
          interval: 0,
          width: 120,
          overflow: "truncate",
          fontSize: 12,
          fontWeight: "bold", 
          formatter: function (value) {
            return value.length > 10 ? value.substring(0, 10) + "..." : value;
          },
        },
      },

      series: series,
      color: ["#d1dc5a", "#6ac5cb", "#45444e", "#a3b85b", "#3a6b74"],
    };

    myChart.setOption(option);

    return () => {
      myChart.dispose();
    };
  }, [data, loading, error]);

  if (loading) {
    return (
      <div className="grafica loading">
        Cargando datos de gestores por tipo de aprovechamiento...
      </div>
    );
  }

  if (error) {
    return (
      <div className="grafica error">
        Error al cargar los datos: {error.message}
      </div>
    );
  }

  return (
    <div className="grafica" ref={chartRef} style={{ height: "600px" }}></div>
  );
};

export default GestoresTipoAprovechamiento;
